// import * as accountApi from '@motionelements/core/src/api/account.js';
import * as elementsApi from '@/api/artist/elements';

const state = {
  mt: null,
  activeStep: 1,
  uploadType: 'single',
  artistMediaTypes: [],
  anyPending: false,
  //
  isLoaded: false,
  //
  uploadMediaTypeGroups: [
    {
      id: 'stock',
      mediaTypes: ['animation', 'video_live', 'music', 'sfx', 'photo', '3d_model', 'lottie', 'vector'],
    },
    {
      id: 'template',
      mediaTypes: ['ae', 'resolve', 'pr', 'fcp', 'graphic_template', 'ui_template', 'presentation_template', 'notion_template'],
    },
    {
      id: 'url',
      mediaTypes: ['notion_template'],
    },
    {
      id: 'prompt',
      mediaTypes: ['image_prompt'],
    },
  ],
};

const getters = {
  groupMediaTypes(state) {
    return (groupId) => {
      const targetGroup = state.uploadMediaTypeGroups.find(({ id }) => id === groupId);
      return _.get(targetGroup, 'mediaTypes', []);
    };
  },
};

const mutations = {
  setMediaType(state, mt) {
    let mtArray = [];
    state.uploadMediaTypeGroups.forEach(({ mediaTypes }) => {
      mtArray = [...mtArray, ...mediaTypes];
    });
    if (mtArray.includes(mt)) state.mt = mt;
    else state.mt = null;
  },
  setUploadType(state, uploadType) {
    state.uploadType = uploadType;
  },
  setActiveStep(state, step) {
    state.activeStep = step;
  },
  setArtistMediaTypes(state, artistMediaTypes) {
    state.artistMediaTypes = artistMediaTypes;
  },
  setAnyPending(state, status) {
    state.anyPending = status;
  },
  //
  setIsLoaded(state, boolean) {
    state.isLoaded = boolean;
  },
  //
  setAiGenerator(state, aiGenerator) {
    if (state.aiGeneratorsList.includes(aiGenerator)) state.aiGenerator = aiGenerator;
  },
};

const actions = {
  createElement(store, { file, mediaType, videoCodec }) {
    const params = {
      url: file.uploadURL.replace('%2Fstock%2F', '/stock/'), // path separators are escaped
      originalPath: file.meta.relativePath || file.meta.name, // uppy will return relatvePath if folder is dropped ELSE it will be null
      mediaType,
      videoCodec,
    };
    return elementsApi.createElement(params);
  },
  GET_ARTIST_ELEMENTS_STATS({ commit }) {
    elementsApi.getElementsStats()
      .then(({ data: { data: stats } }) => {
        let types = stats.map(x => x.mediaType).filter(x => x !== 'all');
        types = types.length ? types : ['video', 'photo', 'music'];
        commit('setArtistMediaTypes', types.slice(0, 5));
        commit('setIsLoaded', true);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
